import { Button, Dropdown, Form, FormInstance, Input, MenuProps, Modal } from "antd";
import './index.less'
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BatchImportAmount from "@/components/BatchImportAmount";
import { cdnUrl } from "@/utils/cdn"; 


export default function CustormAmount(props: { form: any, symbol: any }) {
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a target="_blank" href={cdnUrl("/demo/amount/xlsx-amount-demo.xlsx")} download>
          Excel
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a target="_blank" href={cdnUrl("/demo/amount/csv-amount-demo.csv")} download>
          CSV
        </a>
      )
    },
    {
      key: '3',
      label: (
        <a target="_blank" href={cdnUrl("/demo/amount/txt-amount-demo.txt")} download>
          TXT
        </a>
      ),
    },
    {
      key: '4',
      label: (
        <a target="_blank" href={cdnUrl("/demo/amount/json-amount-demo.json")} download>
          JSON
        </a>
      ),
    },
  ];
  const { t, i18n } = useTranslation()
  const [openModal, setOpenModal] = useState(false);
  const [amounts, setAmounts] = useState('');
  const [form1] = Form.useForm();
  const { form } = props
  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleHideModal = () => {
    setOpenModal(false)
  }

  function onSubmitAmounts() {
    form1.validateFields()
      .then(values => {
        // 表单校验通过，values为表单的值
        console.log('Success:', values);
        const { amounts } = values
        setAmounts(amounts)
        handleHideModal()
        form.setFieldValue('amounts', amounts)
        // 在这里处理表单提交等逻辑
      })
      .catch(errorInfo => {
        // 表单校验失败
        console.log('Failed:', errorInfo);
        // 在这里处理校验失败的逻辑，例如显示错误信息
      });
  }

  function onValuesChange(changedValues: any, allValues: any) {
    console.log(changedValues, allValues, 'changedValues')
  }
  return (
    <>
      <div className="custorm-amount">
        <h3>{t("manyToMany.sendAmountPerAddress")}</h3>
        <Form.Item
          name="amounts"
          label={null}
          noStyle
        >
          <Input type="hidden" />
        </Form.Item>
        <Button type="primary" className="cus-btn" onClick={handleOpenModal}>{t("manyToMany.custom")}</Button>
      </div>
      <Modal
        wrapClassName="sl-upload-modal"
        title={t("manyToMany.customAmount")}
        open={openModal}

        // onOk={handleOk}
        onCancel={handleHideModal}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        footer={null}
        width={868}
        centered
      >
        <Form
          form={form1}
          layout="vertical"
          style={{ width: '100%' }}
          className='cus-form-box'
          // onFinish={onFinish}
          initialValues={{}}
          onValuesChange={onValuesChange}
        >
          {/* <ImportWalletAmount form={form1} /> */}
          <BatchImportAmount form={form1} />

          <Form.Item>
            <div className="form-item-menu-box">
              <div className='demo-box'>
                <Dropdown menu={{ items }} trigger={['click']}>
                  <a onClick={(e) => e.preventDefault()}>
                    {
                      t("components.TemplateFile")
                    }
                  </a>
                </Dropdown>
              </div>
              <div className='btns'>
                <Button type="default" onClick={handleHideModal}>
                  {t('btn.cancel')}
                </Button>
                <Button type="primary" onClick={onSubmitAmounts}>
                  {t('btn.confirm')}
                </Button>
              </div>
            </div>

          </Form.Item>
        </Form>


      </Modal>
    </>
  )
}